module.exports = __webpack_public_path__ + "img/mareto.accb64c8.png";